import Icon from '../components/Icon.vue'

Icon.register({
  'truck-pickup': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 288c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-49.6c0.8 5.3 1.6 10.5 1.6 16 0 61.9-50.1 112-112 112-61.9 0-112-50.1-112-112 0-5.5 0.9-10.7 1.6-16h-67.2c0.8 5.3 1.6 10.5 1.6 16 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-5.5 0.8-10.7 1.6-16h-49.6c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16v-64c0-17.7 14.3-32 32-32h160v-128c0-17.7 14.3-32 32-32h113.2c17 0 39.4 10.8 50 24l108.8 136h48c17.7 0 32 14.3 32 32v64h16zM288 96v96h158l-76.8-96h-81.2zM176 416c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM464 416c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck-pickup.js
// module id = 2038
// module chunks = 0